import { render, staticRenderFns } from "./pullzone_list.vue?vue&type=template&id=3731a43a&"
import script from "./pullzone_list.vue?vue&type=script&lang=js&"
export * from "./pullzone_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports